import VSelectCourseAge from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCourseAge', VSelectCourseAge),
};
